import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';

import logo from '../../../_assets/images/logo.svg';
import { authSelectors } from '../../../_store/selectors';
import { isKbcApp } from '../../../_utils/initializeHelper';

import './examinationlayoutMenu.scss';

const ExaminationLayoutMenu: FC = () => {
  const { pathname } = useLocation();
  const isKbc = isKbcApp();
  const isResultQuestion = pathname === '/result-questions';
  const isStartScreen = pathname === '/start';
  const isEpyc = useSelector(authSelectors.token);

  function canShowImg() {
    if (isKbc && isStartScreen) return true;
    if (isKbc) return false;
    if (isEpyc) return false;
    return true;
  }

  return (
    <header className={classnames('', { 'is-kbc-behaviour': (isKbc && !isStartScreen) || isEpyc })}>
      {!isResultQuestion && (
        <>
          {canShowImg() && (
            <a
              className={classnames({ 'is-kbc-behaviour': isKbc })}
              href={isKbc ? '/' : 'https://www.vab.be/nl/rijschool'}
              rel="noopener noreferrer"
              target={isKbc ? '_self' : '_blank'}
            >
              <img alt="vab-logo" src={logo} />
            </a>
          )}
          <div className="timer" />
        </>
      )}
    </header>
  );
};

export default ExaminationLayoutMenu;
